export const ORDER_STATUS_ENUMS = {
  CANCELLED: 6,
};

export const QR_ORDERING_PLAN = {
  STATIC: 0,
  DYNAMIC: 1,
  BOTH: 2,
};
